import { useState, useLayoutEffect, useCallback } from 'react';

export const useImageLoading = (src: string) => {
    const [loading, setLoading] = useState(true);

    const onLoad = useCallback(() => {
        setLoading(false);
    }, []);

    useLayoutEffect(() => {
        const img = document.createElement('img');
        img.src = src;
        img.onload = () => onLoad();
    }, [src, onLoad]);

    return { loading, onLoad };
};
